module.exports = __webpack_public_path__ + "img/imgBaby01.20329e49.jpg";